import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/apply'
  },
  {
    name: 'dispatcher',
    component: () => import('./view/dispatcher'),
    meta: {
      title: '路由'
    }
  },
  {
    name: 'order',
    component: () => import('./view/order'),
    meta: {
      title: '我的分析'
    }
  },
  {
    name: 'apply',
    component: () => import('./view/apply'),
    meta: {
      title: '下单'
    }
  },
  {
    path: '/pdf',
    component: () => import('./view/pdf/index'),
    hidden: true
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ 
  // mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
